// import node package 'pdfjs-dist'
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.js";
pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

document.addEventListener('turbolinks:load', () => {
    const currentTextSize = document.getElementById('currentTextSize')
    let textSizeModifier = 1 // 1.75 | 1.4 | 1

    const selfGuidedStationScreenPreview = document.getElementById('selfGuidedStationScreenPreview')
    const selfGuidedMultiStationScreenPreview = document.getElementById('selfGuidedMultiStationScreenPreview')
    const sgScreen = document.getElementById('sgScreen')
    const richTextAreas = document.getElementsByClassName("trix-content")
    const selfGuidedContentScrollArea = document.getElementById('selfGuidedContentScrollArea')
    const selfGuidedStationTopBar = document.getElementById('selfGuidedStationTopBar')
    const selfGuidedStationStatusBar = document.getElementById('selfGuidedStationStatusBar')
    const selfGuidedStationPreviewWebsite = document.getElementById('selfGuidedStationPreviewWebsite')
    const pdfPreviewContainer = document.getElementById('pdfPreviewContainer')

    // pdf load logic
    let loadQueue = Promise.resolve(); // queue pdf loads on resize
    let loadingTask = null; // To track the current PDF loading task
    let latestTaskId = 0; // save current PDF load task id

    //Used in all self_guided stations
    if (selfGuidedStationScreenPreview !== null && sgScreen !== null && selfGuidedContentScrollArea !== null &&
        selfGuidedStationTopBar !== null && selfGuidedStationStatusBar !== null) {
        if (currentTextSize != null){
            if (currentTextSize.value === "very large") {
                textSizeModifier = 1.75
            } else if (currentTextSize.value === "large") {
                textSizeModifier = 1.4
            }
        }
        resize()
        handleScroll()

        $(".previewExpandText").click(expandText)
        $(".previewCollapseText").click(collapseText)
    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height
            const currentSgScreenWidth = sgScreen.getBoundingClientRect().width

            // trix
            if(selfGuidedMultiStationScreenPreview !== null){
                //Multi Station
                for (let richTextArea of richTextAreas) {
                    // guide detail
                    richTextArea.style.fontSize = `${currentSgScreenHeight / 45 * textSizeModifier}px`
                    richTextArea.style.lineHeight = `${currentSgScreenHeight / 27 * textSizeModifier}px`
                    const h1s = richTextArea.getElementsByTagName('h1')
                    for (let h1 of h1s) {
                        h1.classList.add('font-bold')
                        h1.style.fontSize = `${currentSgScreenHeight / 32 * textSizeModifier}px`
                    }
                }
            } else {
                //Single Station
                for (let richTextArea of richTextAreas) {
                    // guide detail
                    richTextArea.style.fontSize = `${currentSgScreenHeight / 50 * textSizeModifier}px`
                    richTextArea.style.lineHeight = `${currentSgScreenHeight / 32 * textSizeModifier}px`
                    const h1s = richTextArea.getElementsByTagName('h1')
                    for (let h1 of h1s) {
                        h1.classList.add('font-bold')
                        h1.style.fontSize = `${currentSgScreenHeight / 32 * textSizeModifier}px`
                    }
                }
            }

            // resize iframe to hide scrollbar
            if (selfGuidedStationPreviewWebsite != null) {
                selfGuidedStationPreviewWebsite.style.width = `${currentSgScreenWidth + 17}px`
            }

            // resize pdf
            if (pdfPreviewContainer !== null) {
                // Cancel the currently running PDF load (if any)
                if (loadingTask) {
                    loadingTask.destroy();
                    loadingTask = null;
                }

                // Generate a new unique ID for the latest resize event
                const currentTaskId = ++latestTaskId;

                // Add a new PDF load task to the queue, ensuring sequential execution.
                // Any outdated tasks (from previous resizes) will be skipped, and only the latest one will run.
                loadQueue = loadQueue.then(() => {
                    //sequential part -one resize after the other

                    // Ignore outdated tasks
                    if (currentTaskId !== latestTaskId) {
                        return; // Ignore outdated tasks
                    }
                    // executes the latest load
                    return loadPdf()
                });
            }

        })
        resizeObserver.observe(sgScreen);
    }

    // change top-bar color if users scrolls
    function handleScroll() {
        let topBarBackground = (sgScreen.classList.contains('bg-gray-900') ? "bg-gray-700" : "bg-gray-300")
        selfGuidedContentScrollArea.addEventListener("scroll", (e) => {
            if (selfGuidedContentScrollArea.scrollTop === 0) {
                selfGuidedStationTopBar.classList.remove(topBarBackground)
                selfGuidedStationStatusBar.classList.remove(topBarBackground)
            } else {
                selfGuidedStationTopBar.classList.add(topBarBackground)
                selfGuidedStationStatusBar.classList.add(topBarBackground)
            }
        });
    }

    function expandText(evt){
        let pressedButton = evt.target
        let textContainer = pressedButton.closest(".guestStationPreviewText")
        for (let text of textContainer.children){
            if (text.dataset.expanded === "true"){
                text.classList.remove('hidden')
            } else {
                text.classList.add('hidden')
            }
        }
    }

    function collapseText(evt){
        let pressedButton = evt.target
        let textContainer = pressedButton.closest(".guestStationPreviewText")
        for (let text of textContainer.children){
            if (text.dataset.expanded === "true"){
                text.classList.add('hidden')
            } else {
                text.classList.remove('hidden')
            }
        }
    }

    /**
     * Loads the PDF from the URL specified in the `data-pdf-url` attribute of `pdfPreviewContainer`.
     *
     * This function:
     * - Retrieves the PDF URL dynamically.
     * - Starts a new PDF loading task using `pdfjsLib.getDocument()`.
     * - Returns a promise that resolves when the PDF is fully loaded.
     * - Ensures only the latest PDF is loaded, as older tasks are ignored in the main execution flow.
     */
    function loadPdf() {
        // Start loading the PDF document asynchronously using pdf.js
        const url = pdfPreviewContainer.dataset.pdfUrl
        loadingTask = pdfjsLib.getDocument(url)

        // Return a promise that resolves when the PDF is fully loaded
        return loadingTask.promise
            .then(pdf => {
                pdf.getPage(1).then(page => {

                    // get pdf dimensions
                    const originalViewport = page.getViewport({ scale: 1 });
                    const originalWidth = originalViewport.width;
                    const originalHeight = originalViewport.height;

                    // Get pdfPreviewContainer dimensions (already fixed)
                    const pdfPreviewContainer = document.getElementById('pdfPreviewContainer')

                    // handle running promise after navigating away
                    if (pdfPreviewContainer == null) {
                        return
                    }

                    const containerWidth  = pdfPreviewContainer.getBoundingClientRect().width;
                    const containerHeight  = pdfPreviewContainer.getBoundingClientRect().height;

                    // Calculate scale to fit while maintaining aspect ratio
                    const scaleX = containerWidth / originalWidth;
                    const scaleY = containerHeight / originalHeight;
                    const scale =  Math.min(scaleX, scaleY) ; // Use the smaller scale to avoid distortion

                    // Create a newCanvas inside pdfPreviewContainer
                    const newCanvas = document.createElement("canvas");
                    newCanvas.id = "pdfCanvas"
                    const context = newCanvas.getContext("2d");

                    // Compute the new viewport with correct scaling
                    const scaledViewport = page.getViewport({ scale });

                    // Set the newCanvas dimensions based on scaled PDF size
                    newCanvas.width = scaledViewport.width;
                    newCanvas.height = scaledViewport.height;

                    // Append newCanvas to the div container
                    const oldCanvas = document.getElementById('pdfCanvas')
                    if (oldCanvas !== null) {
                        pdfPreviewContainer.replaceChild(newCanvas, oldCanvas)
                    } else {
                        pdfPreviewContainer.appendChild(newCanvas);
                    }


                    // Render PDF on newCanvas
                    const renderContext = {
                        canvasContext: context,
                        viewport: scaledViewport
                    };

                    page.render(renderContext)
                })
            })
            .catch(() => {

            })
            .finally(() => {
                loadingTask = null;
            });
    }

})